import Vue from "vue";
import Router from "vue-router";
import Homepage from "./views/homepage/Homepage.vue";
import Application from "./views/application/Application.vue";

Vue.use(Router);

export default new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			name: "homepage",
			component: Homepage
		},
		{
			path: "/404",
			name: "404",
			component: () => import("./views/errors/404.vue")
		},
		{
			path: "/app/:slug",
			name: "application",
			component: Application
		}
	]
});
